import LogoBig from '../images/logoBig.png';

export default function HomeRedirect() {
    return (
        <div style={{
            width: '100%',
            height: '100%',
            backgroundColor: '#F6F1FE',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            rowGap: '40px',
            padding: '32px',
            boxSizing: 'border-box',
        }}>
            <img src={LogoBig} alt="logo" style={{width: '135px'}} />
            <div style={{
                fontSize: '24px',
                fontWeight: 500,
                textAlign: 'center',
                width: '100%',
            }}>
                Baobab déménage avec de nouvelles fonctionnalités !
            </div>

            <div style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                rowGap: '40px',
            }}>
                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    rowGap: '4px',
                }}>
                    <div style={{
                        fontSize: '12px',
                        fontWeight: 700,
                        textAlign: 'center',
                        width: '100%',
                        color: '#8C4AF8',
                    }}>
                        ÉTAPE 1
                    </div>
                    <div style={{
                        fontSize: '20px',
                        fontWeight: 700,
                        textAlign: 'center',
                        width: '100%',
                    }}>
                        Connectez-vous sur
                        <br/>
                        <a href="https://app.baobab-labs.com" style={{color:'#8C4AF8',cursor:'pointer'}}>
                            app.baobab-labs.com
                        </a>
                    </div>
                </div>

                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    rowGap: '4px',
                }}>
                    <div style={{
                        fontSize: '12px',
                        fontWeight: 700,
                        textAlign: 'center',
                        width: '100%',
                        color: '#8C4AF8',
                    }}>
                        ÉTAPE 2
                    </div>
                    <div style={{
                        fontSize: '20px',
                        fontWeight: 700,
                        textAlign: 'center',
                        width: '100%',
                    }}>
                        Installez Baobab sur votre écran d'accueil
                        <br/>
                        <span style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            textAlign: 'center',
                            width: '100%',
                        }}>
                            cette étape est similaire au tutoriel précédemment envoyé
                        </span>
                    </div>
                </div>

                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    rowGap: '4px',
                }}>
                    <div style={{
                        fontSize: '12px',
                        fontWeight: 700,
                        textAlign: 'center',
                        width: '100%',
                        color: '#8C4AF8',
                    }}>
                        ÉTAPE 3
                    </div>
                    <div style={{
                        fontSize: '20px',
                        fontWeight: 700,
                        textAlign: 'center',
                        width: '100%',
                    }}>
                        Connectez-vous avec vos identifiants
                        <br/>
                        <span style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            textAlign: 'center',
                            width: '100%',
                        }}>
                            Et retrouvez toutes vos leçons !
                        </span>
                    </div>
                </div>
            </div>
            <div style={{
                fontSize: '20px',
                fontWeight: 700,
                textAlign: 'center',
                width: '100%',
            }}>
                À bientôt sur Baobab ! 👋
            </div>
        </div>
    )
}